module.exports = __webpack_public_path__ + "img/kong.d98eb487.png";